// Path: ./src/app/components/SideFlyerGridList/styled.ts
import { Grid, styled as MUiStyled, Paper } from "@mui/material";
import styled from "styled-components";

export const Wrapper = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  overflow-y: auto;
  /* margin-top: 10px; */
  min-height: 0;
  @media (max-width: 899px) {
    margin-left: 0px;
    margin-top: 10px;
    flex: 0 0 auto;
    max-height: 500px;
    min-height: 500px;
  }
`;

export const GridContainer = MUiStyled(Grid)(() => ({
  height: "100%",
  paddingTop: 10,
  paddingBottom: 30,
  background: "transparent",
  borderRadius: "8px",
  maxWidth: "100%",
}));

export const Item = MUiStyled(Paper)(() => ({
  textAlign: "center",
  boxShadow: "none",
  margin: "auto",
  background: "transparent",
  cursor: "pointer",
  padding: "5px",
}));

export const ImageWrapper = styled.div<{ hasUsageHistory?: boolean }>`
  padding: 10px;
  box-shadow: 0px 0px 26px -2px
    ${(props) => (props.hasUsageHistory ? "#ff813a80" : "#cdcdcd")};
  border-radius: 8px;
  outline: none;
  text-decoration: none;
  border: ${(props) => (props.hasUsageHistory ? "2px solid #ff813a40" : "0px")};
  background: white;
  width: 100%;
  position: relative;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0px 0px 30px -2px
      ${(props) => (props.hasUsageHistory ? "#ff813a" : "#cdcdcd")};
    transform: ${(props) =>
      props.hasUsageHistory ? "translateY(-2px)" : "none"};
  }

  .tag-edit-btn {
    opacity: 0;
    transition: opacity 0.2s;
  }

  &:hover .tag-edit-btn {
    opacity: 1;
  }
`;

export const Title = styled.div`
  font-size: 14px;
  font-family: system-ui;
  text-align: start;
  margin-top: 6px;
  padding-left: 3px;
  overflow-wrap: break-word;
`;

export const ImageIcon = styled.div`
  position: absolute;
`;

export const NoImageFoundWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  visibility: hidden;
  animation: appear 0.1s ease forwards 0.2s;
  background-color: transparent;
  overflow: hidden;
  @keyframes appear {
    to {
      opacity: 1;
      visibility: visible;
    }
  }
`;

export const HelperTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
  color: #a3a3a3;
  background-color: transparent;
`;

export const HelperText = styled.h4`
  text-align: center;
`;
